'use client';

import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { Box, IconButton, Tooltip, type SxProps } from '@mui/material';
import type { IframeController } from '@ocodelib/iframe-parent';
import { flatSx, FlexColumn, FlexRow } from '@ocodelib/mui';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { IframeWrapperNoSsr } from '../iframes';
import { usePyBasicApp } from '../usePyBasicApp';

interface Props {
  sx?: SxProps;
  className?: string;
}

export function ConsoleContainer(props: Props) {
  const { sx, className } = props;
  const { app, appManager } = usePyBasicApp();
  const [refreshToken, setRefreshToken] = useState(0);
  const [iframeController, setIframeController] = useState<IframeController | null>(null);
  const datiBaseURL = appManager.appConfig.datiBaseURL;

  useEffect(() => {
    if (!app) return;
    app.setExecIframe(iframeController);
  }, [app, iframeController]);

  const handleLoadIframe = (iframe: IframeController | null) => {
    setIframeController(iframe);
  };

  return (
    <FlexColumn
      className={clsx('ConsoleContainer-root', className)}
      sx={flatSx(
        {
          height: '100%',
          borderTop: '1px solid #ddd',
          borderLeft: '1px solid #ddd',
        },
        sx,
      )}
    >
      <HeaderBox
        disabled={!app}
        onClickConsoleClear={() => {
          app.clearLogs();
        }}
      />
      <Box
        sx={{
          position: 'relative',
          flex: 1,
          '& > iframe': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          },
        }}
      >
        <IframeWrapperNoSsr
          key={refreshToken}
          datiBaseURL={datiBaseURL}
          // devUrl="http://localhost:9011"
          className="LayoutRightPane-iframe"
          idPrefix="py-runner-code"
          urlPath="/sys.iframe/py-runner/code.html"
          onLoad={handleLoadIframe}
        />
      </Box>
    </FlexColumn>
  );
}

function HeaderBox(props: { disabled?: boolean; onClickConsoleClear?: React.MouseEventHandler }) {
  const { disabled, onClickConsoleClear } = props;
  return (
    <FlexRow.End
      alignItems="center"
      sx={{
        bgcolor: '#edeff1',
        height: 40,
        px: 2,
      }}
    >
      <Tooltip title="clear log">
        <span>
          <IconButton
            size="small"
            color="primary"
            disabled={disabled}
            onClick={onClickConsoleClear}
            sx={{ ml: 'auto', color: '#888' }}
          >
            <CleaningServicesIcon />
          </IconButton>
        </span>
      </Tooltip>
    </FlexRow.End>
  );
}
